/**
 * @class
 * @classdesc Model for WhitelistUser on DB
 * * */
export default class Owner {
  /**
   *Constructor - sets a model for whitelist user Data according to DB
   * @param {Number} id
   * @param {Number} fleetId
   * @param {Number} clientId
   * @param {String} phoneNumber
   * @param {String} carNumber
   * @param {String} email
   * @param {String} name
   * @param {String} registrationType
   * @param {String} registeredAt
   * @param {String} comment
   * @param {Number} dailyLimitInCents
   * @param {Number} monthlyLimitInCents
   * @param {String} status
   */

  #FleetUserObject = {}

  constructor(
    id,
    fleetId,
    clientId,
    phoneNumber,
    carNumber,
    email,
    name,
    registrationType,
    comment,
    dailyLimitInCents,
    monthlyLimitInCents,
    status
  ) {
    this.#FleetUserObject.Id = id || null
    this.#FleetUserObject.FleetId = fleetId || null
    this.#FleetUserObject.ClientId = clientId || null
    this.#FleetUserObject.PhoneNumber = phoneNumber || ''
    this.#FleetUserObject.CarNumber = carNumber || ''
    this.#FleetUserObject.Email = email || ''
    this.#FleetUserObject.Name = name || ''
    this.#FleetUserObject.RegistrationType =
      registrationType || 'MANUALLY_ADDED'
    this.#FleetUserObject.Comments = comment || ''
    this.#FleetUserObject.DailyLimitInCents = dailyLimitInCents || null
    this.#FleetUserObject.MonthlyLimitInCents = monthlyLimitInCents || null
    this.#FleetUserObject.Status = status || 'PENDING'
  }

  /**
   * Get Whitelist Object
   * @return {Object} Whitelist Javascript object
   */
  getObject() {
    return this.#FleetUserObject
  }
}
